import { useDark, useStorage, useToggle } from '@vueuse/core'
import { defineStore } from 'pinia'
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'

export const useTheme = () => {
    // dark theme
    const isDarkTheme = useDark({
        valueDark: 'theme theme--dark',
        valueLight: 'theme theme--light',
    })
    const toggleDarkTheme = useToggle(isDarkTheme)
    const theme = computed(() => {
        if (isDarkTheme.value) {
            return 'dark'
        }
        return 'light'
    })
    return {
        isDarkTheme,
        toggleDarkTheme,
        theme,
    }
}

export const useSettingsStore = defineStore('settings', () => {
    // dark theme
    const { isDarkTheme, toggleDarkTheme } = useTheme()

    // sidebar
    const isSidebarOpen = useStorage('isSidebarOpen', false)
    const toggleSidebarOpen = useToggle(isSidebarOpen)
    const isSidebarFolded = useStorage('isSidebarFolded', false)
    const toggleSidebarFolded = useToggle(isSidebarFolded)

    const route = useRoute()
    const hasSidebar = computed(() =>
        route.matched.some((record) => record.meta.hasSidebar),
    )
    watch(route, () => {
        // close sidebar on route change (for mobile devices)
        isSidebarOpen.value = false
    })

    return {
        isDarkTheme,
        toggleDarkTheme,
        hasSidebar,
        isSidebarOpen,
        toggleSidebarOpen,
        isSidebarFolded,
        toggleSidebarFolded,
    }
})
